module.exports = __webpack_public_path__ + "static/media/empty-state-fuel.844d54d5.svg";